import { styled } from "@mui/material/styles";
import { FiEdit, FiTrash2 } from "react-icons/fi";

export const Wrapper = styled("div")(() => ({
  width: "100%",
}));

export const Header = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
}));

export const EmptySection = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  padding: "32px 0",
  marginTop: 16,
  backgroundColor: "#F9FAFB",
}));

export const Title = styled("span")(() => ({
  fontfamily: "Manrope",
  fontSize: 24,
  fontWeight: 500,
  lineheight: "32px",
  color: "#475467",
  marginBottom: 16,
}));

export const Message = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineheight: "20px",
  color: "#475467",
}));

export const TrashIcon = styled(FiTrash2)(() => ({
  cursor: "pointer",
}));

export const EditIcon = styled(FiEdit)(() => ({
  cursor: "pointer",
}));

export const SingleUseBadge = styled("div")(() => ({
  background: "#F9FAFB !important",
  color: "#475467",
  borderRadius: "4px",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  letterSpacing: "0.5px",
  lineHeight: "16px",
  marginInline: "12px",
  padding: "4px 8px",
}));

export const IconWrapper = styled("div")(() => ({
  cursor: "pointer",
}));
